
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { AtividadeChecklistItem } from '../atividade-checklist-item';

@Injectable({
    providedIn: 'root'
})
export class AtividadeChecklistItemHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/atividade`;
    }

    /** Pesquisa todos os itens do checklist da tividade informada */
    search(idAtividade: number): Observable<AtividadeChecklistItem[]> {
        return this.customHttp.get<AtividadeChecklistItem[]>(`${this.pathApi}/${idAtividade}/checklistitem`);
    }

    /** Carrega um item do checklist da atividade através do seu ID */
    load(id: number): Observable<AtividadeChecklistItem> {
        return this.customHttp.get<AtividadeChecklistItem>(`${this.pathApi}/0/checklistitem/${id}`);
    }

    /** Insere no item no checklist da atividade */
    insert(entity: AtividadeChecklistItem): Observable<AtividadeChecklistItem> {
        return this.customHttp.post<AtividadeChecklistItem>(`${this.pathApi}/0/checklistitem`, entity);
    }

    /** Atualiza um item no checklist da atividade */
    update(entity: AtividadeChecklistItem): Observable<AtividadeChecklistItem> {
        return this.customHttp.put<AtividadeChecklistItem>(`${this.pathApi}/0/checklistitem/${entity.id}`, entity);
    }

    /** Realiza o update da conclusão de um item do checklist da atividade */
    updateConcluido(idAtividade: number, id: number, concluido: boolean): Observable<AtividadeChecklistItem> {
        return this.customHttp.put<AtividadeChecklistItem>(`${this.pathApi}/${idAtividade}/checklistitem/${id}/concluido/${concluido ? concluido.toString() : 'false'}`, null);
    }

    /** Deleta um iten do checklist da atividade através do seu ID */
    delete(idAtividade: number, id: number): Observable<string> {
        return this.customHttp.delete<string>(`${this.pathApi}/${idAtividade}/checklistitem/${id}`);
    }
}
